import React, { useMemo } from 'react'

import { Box, useTokens } from '@barracuda-internal/bds-core-v2'
import { LogoPrimary } from '@barracuda-internal/bds-core/dist/Logos/Barracuda'
import { QN2CActionHandler } from 'components/pages/quarantineAction/Qn2cActionHandler'
import { Pending } from 'components/pages/quarantineAction/Pending'
import LoginFooter from 'components/libs/layout/footer/loginFooter/LoginFooter'
import { UseQn2cFeatureLogicProps } from 'components/pages/quarantineAction/useQn2cFeatureLogic'
import Error from 'components/pages/quarantineAction/Error'

type SignatureStatus = 'pending' | 'ready' | 'error' | 'idle'
interface Qn2cFeatureLayoutProps {
  logic: UseQn2cFeatureLogicProps
}

const getSignatureStatus = (loading: boolean, jwtReturnedValue: any, error: string): SignatureStatus => {
  if (loading) return 'pending'
  if (jwtReturnedValue) return 'ready'
  if (error) return 'error'
  return 'idle'
}
// Height reserved for footer not to cover content
const RESERVED_FOOTER_HEIGHT = 200

const Qn2cFeatureLayout = ({ logic }: Qn2cFeatureLayoutProps) => {
  const tokens = useTokens()
  const { jwtReturnedValue, error, loading } = logic

  const signatureStatus = getSignatureStatus(loading, jwtReturnedValue, error)

  return useMemo(() => {
    const evaluateFlowChart = (): React.ReactNode => {
      if (signatureStatus === 'pending') {
        return <Pending />
      }
      if (signatureStatus === 'ready') {
        return <QN2CActionHandler logic={logic} />
      }
      if (signatureStatus === 'error') {
        return <Error {...logic.mapErrorActionProps()} />
      }
      return null
    }

    return (
      <Box
        sx={{
          height: '100vh',
          display: 'flex',
          flexDirection: 'column',
          paddingBottom: `calc(env(safe-area-inset-bottom) + ${RESERVED_FOOTER_HEIGHT}px)`
        }}
      >
        <Box sx={{ padding: tokens.aliasesSpaceContainerSpacious, textAlign: 'center' }}>
          <LogoPrimary height={40} />
        </Box>
        <Box sx={{ flex: 1, display: 'flex', justifyContent: 'center', overflow: 'auto' }}>{evaluateFlowChart()}</Box>
        <LoginFooter />
      </Box>
    )
  }, [tokens.aliasesSpaceContainerSpacious, signatureStatus, logic])
}
export default Qn2cFeatureLayout
